import { render, staticRenderFns } from "./AdminUnternehmenProfile.vue?vue&type=template&id=4756e2af&scoped=true&"
import script from "./AdminUnternehmenProfile.vue?vue&type=script&lang=ts&"
export * from "./AdminUnternehmenProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AdminUnternehmenProfile.vue?vue&type=style&index=0&id=4756e2af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4756e2af",
  null
  
)

export default component.exports